import type { ReactNode } from "react";
import styles from "./FormField.module.css";

interface FormFieldProps {
	children: ReactNode;
	label?: string;
	htmlFor?: string;
	error?: boolean;
	className?: string;
	required?: boolean;
}

export function FormField({
	children,
	label,
	htmlFor,
	error = false,
	className = "",
	required = false,
}: FormFieldProps) {
	return (
		<div className={`${styles.container} ${className}`}>
			{label && (
				<label
					htmlFor={htmlFor}
					className={`${styles.label} ${error ? styles.labelError : ""}`}
				>
					{label}
					{required && <span className={styles.required}>*</span>}
				</label>
			)}
			<div className={styles.fieldWrapper}>{children}</div>
		</div>
	);
}
